import ActivationSummary from '@/components/settings/ActivationSummary';

export default function ResumenPage() {
  return <ActivationSummary />;
}
